module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEKSURBVEhL7dM7igJBFIXhDg18oGgkTKYrEcwMfOxGYWYlg7FbmExdhJqImqgLMNT/YBcURb+mqrOZAx823XhudRUd/SchW2zel+XELVzHcvN0pKVwoZu0AXlbUHiL0gbkrTj3jfr4gTtA93pw86tD/cANbrlxRRd23BVnDlwiqdj2jaxkbpFWmFRq0xt6x5ScMEEtNsYe5rl39OczOvjCBXeM0IKeBQ+Y4jO+lhUq0JBZfM87+nMVZqWmXL/a+zqCB2jPVWaX676GljJAB6rtsMtlAR188IAdmtAQHbAOeo42DggeICrVgWpLGtDKTXnQgAdMSRbv2B9TGn2E3hngiKRiUfkQfyZR9AKtYo26lDgY2QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-insecticide/dark/24.png
// module id = 2190
// module chunks = 2